/**
 * We'll load jQuery and Bootstrap, which provides support for JavaScript-based
 * Bootstrap features such as modals and tabs. This code may be
 * modified to fit the specific needs of your application.
 */

import $ from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = $;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
